const units = {
  '十亿': 1000000000,
  '亿': 100000000,
  '千万': 10000000,
  '万': 10000,
  '千': 1000
}
/**
 *数据以个位数为单位时适用
 * @param {
 * val
 * base: 换算基数单位
 * unitText: 是否拼接单位名
 * }
 */
module.exports.formatUnit = function (val, base, unitText = true, precision = 2) {
  const number = +val
  if (!number && number !== 0) return '--'
  const absValue = Math.abs(val)
  if (base) {
    if (/^\d+$/.test(base)) {
      return `${(val-0).toFixed(base)}`
    }
    return `${(val / units[base]).toFixed(2)}${unitText ? base : ''}`
  }
  if (absValue > 100000000) {
    return `${(number / 100000000).toFixed(2)}${unitText ? '亿' : ''}`
  } else if (absValue > 10000000) {
    return `${(number / 10000000).toFixed(2)}${unitText ? '千万' : ''}`
  } else if (absValue > 10000) {
    return `${(number / 10000).toFixed(2)}${unitText ? '万' : ''}`
  } else {
    return number.toFixed(precision)
  }
}

/**
 *数据以个位数为单位时适用
 * @param {
 * val
 * base: 换算基数单位
 * unitText: 是否拼接单位名
 * hasPrecision: 不到万位的是否要小数点
 * }
 */
module.exports.formatUnit = function (val, base, unitText = true, precision = 2, hasPrecision = true) {
  const number = +val
  if (!number && number !== 0) return '--'
  const absValue = Math.abs(val)
  if (base) {
    if (/^\d+$/.test(base)) {
      return `${(val-0).toFixed(base)}`
    }
    return `${(val / units[base]).toFixed(2)}${unitText ? base : ''}`
  }
  if (absValue > 100000000) {
    return `${(number / 100000000).toFixed(2)}${unitText ? '亿' : ''}`
  } else if (absValue > 10000000) {
    return `${(number / 10000000).toFixed(2)}${unitText ? '千万' : ''}`
  } else if (absValue > 10000) {
    return `${(number / 10000).toFixed(2)}${unitText ? '万' : ''}`
  } else {
    return hasPrecision ? number.toFixed(precision) : number
  }
}

module.exports.toFixed = function (val, num = 2) {
  return val ? val.toFixed(num) : 0
}

// long 转换成时分秒
module.exports.dateLongToDate = function (datelong, hasMinute = false) {
  let date = new Date(datelong)
  return `${date.getHours().toString().padStart(2, 0)}:${date.getMinutes().toString().padStart(2, 0)}:${date.getSeconds().toString().padStart(2, 0)}`
}

// long 转换成时分
module.exports.dateLongToMinute = function (datelong, hasMinute = false) {
  let date = new Date(datelong)
  return `${date.getHours().toString().padStart(2, 0)}:${date.getMinutes().toString().padStart(2, 0)}`
}

// long 转换为时间，如果为当天则获取 时：分， 否则 月-日 时：分
module.exports.getTimesForDate = function (dateStr) {
  let nowday = new Date()
  let day = dateStr.split(' ')[0].split('-')
  let times = dateStr.split(' ')[1].split(':')
  // 非科学判断，仅从 月 日 和 周几 完全一致来进行判断，很少出现
  // nowday.getMonth() === day.getMonth() && 
  if ((nowday.getMonth()+1) === +day[1] && nowday.getDate() === +day[2]) {
    return `${times[0].toString().padStart(2, 0)}:${times[1].toString().padStart(2, 0)}`
  } else {
    return `${day[1].toString().padStart(2, 0)}-${day[2].toString().padStart(2, 0)} ${times[0].toString().padStart(2, 0)}:${times[1].toString().padStart(2, 0)}`
  }
}

// long 转换为时间，如果为当天则获取 时：分， 否则 月-日 时：分
module.exports.getTimesForDatelong = function (datelong) {
  let day = new Date(datelong) 
  // console.log('datelong', day, day.getFullYear())
  return `${day.getFullYear()}-${(day.getMonth() + 1).toString().padStart(2, 0)}-${day.getDate().toString().padStart(2, 0)}`
}

// 字符串时间转换为 year-month-day
module.exports.getDateStringForLong = function (datelong, val = '-') {
  let day = new Date(datelong)
  return `${day.getFullYear()}${val}${(day.getMonth()+1).toString().padStart(2, 0)}${val}${day.getDate().toString().padStart(2, 0)}`
}

// 字符串时间转换为 month-day
module.exports.getDateStringForMonth = function (datelong, val = '-') {
  let day = new Date(datelong)
  return `${(day.getMonth()+1).toString().padStart(2, 0)}${val}${day.getDate().toString().padStart(2, 0)}`
}

module.exports.getTodayYesterday = function (value) {
  if (!value) return ''
  let todayText = '今天'
  const yesterdayText = '昨天'
  const date = value instanceof Date ? value : new Date(value)
  const today = new Date()
  const yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)

  // console.log('value', value, date.getDate(), today.getDate())

  if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() === today.getDate()) {
    return todayText
  } else if (date.getFullYear() === yesterday.getFullYear() && date.getMonth() === yesterday.getMonth() && date.getDate() === yesterday.getDate()) {
    return yesterdayText
  }
}

module.exports.getIsToday = function (value) {
  if (!value) return false
  const date = value instanceof Date ? value : new Date(value)
  const today = new Date()

  if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() === today.getDate()) {
    return true
  } else return false
}

// long to 
module.exports.getYYYYMMDDHHMMSS = function () {
  let now = new Date()
  return `${now.getFullYear()}-${(now.getMonth()+1).toString().padStart(2, 0)}-${now.getDate().toString().padStart(2, 0)} ${now.getHours().toString().padStart(2, 0)}:${now.getMinutes().toString().padStart(2, 0)}`
}

// long to 
module.exports.getHHMM = function (long) {
  let now = new Date(long)
  return `${now.getHours().toString().padStart(2, 0)}:${now.getMinutes().toString().padStart(2, 0)}`
}

module.exports.getColor = function (up) {
  if (up > 0) {
    return '#eb0000'
  } else if (up < 0) {
    return '#249000'
  } else {
    return ''
  }
}

const trade = {
  1: '无效状态',
	2: '开市',
  3: '交易中',
  4: '收市',
  5: '休市',
  6: '停牌',
  7: '集合竞价',
  8: '熔断',
  9: '日间竞价',
  10: '尾盘竞价',
  11: '非活跃',
  12: '盘前交易',
  13: '盘后交易',
  14: '日间闭市',
  15: '报价阶段',
	16: '停牌一小时',
	17: '停牌一天',
  18: '连续停牌',
	19: '盘中停牌',
	20: '停牌半天',
	21: '暂停',
}

module.exports.getGszt = function (type) {
  return trade[type]
}
